import { useEffect, useRef } from 'react';

import {
  useClientEnvironment,
  useUserEnvironmentActions,
} from '#/contexts/UserEnvironmentContext';

export function LoadEnvironmentGlobalHandler() {
  const { clientEnvironment } = useClientEnvironment();
  const { fetchUserEnvironment } = useUserEnvironmentActions();

  const triggeredRef = useRef(Boolean(clientEnvironment));
  useEffect(() => {
    if (triggeredRef.current) return;
    triggeredRef.current = true;

    void fetchUserEnvironment();
  }, [fetchUserEnvironment]);

  return null;
}
